export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5267.9482b28c.jpg";